import React from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../../../Context';
import Flex from '@wix/da-ds/pkg/Flex';
import ActionBarStrip from '../../../_partials/ActionBarStrip';
import FluidMargin from '../FluidMargin';
import { isTextualDeviation } from '../../../../DeviationViews/_helpers';
import CommentButton from '../../../buttons/CommentButton';
import FavouriteButton from '../../../buttons/FavouriteButtonWithPopover';
import AddToGroupButton from '../../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../../buttons/MoreButton';
import { useElementPlacementForArea } from '../../../ElementPlacementContext/utils';
import { StandardDeviationElementPlacementContext } from '../../../ElementPlacementContext/variants/standard/context';
import { StandardDeviationElementPlacement } from '../../../ElementPlacementContext/variants/standard/types';
import BoostButton from '../../../buttons/BoostButton';
import { ActionBarProps as Props } from '../../../types';

import desktopActionBarStyles from '../DesktopActionBar.scss';

export const SecondaryDesktopActionBar: React.FC<Props> = ({
  deviation,
  isOwner,
  className,
}) => {
  const secondaryBarElementPlacement = useElementPlacementForArea(
    StandardDeviationElementPlacement.SecondaryBar,
    StandardDeviationElementPlacementContext
  );
  const { isTheater } = useDeviationViewContext();

  const isTextual = isTextualDeviation(deviation);

  return (
    <ActionBarStrip
      className={classnames(
        desktopActionBarStyles['root'],
        isTheater
          ? desktopActionBarStyles['theater']
          : desktopActionBarStyles['normal-view'],
        isOwner && desktopActionBarStyles['owner'],
        isTextual && desktopActionBarStyles['literature'],
        desktopActionBarStyles['secondary'],
        className
      )}
    >
      <div className={desktopActionBarStyles['icons-wrapper']}>
        <div className={desktopActionBarStyles['badge']} />
        <FluidMargin index={1} />
        <div className={desktopActionBarStyles['icons-middle']}>
          <Flex alignItems="center">
            {secondaryBarElementPlacement.favourite && (
              <span className={desktopActionBarStyles['icon']}>
                <FavouriteButton
                  deviation={deviation}
                  actionBarType="secondary"
                />
              </span>
            )}
            {secondaryBarElementPlacement.comment && (
              <span className={desktopActionBarStyles['icon']}>
                <CommentButton
                  deviation={deviation}
                  isOwner={isOwner}
                  actionBarType="secondary"
                />
              </span>
            )}
          </Flex>
          <FluidMargin index={4} />
          <Flex alignItems="center">
            {secondaryBarElementPlacement.addToGroup && (
              <span className={desktopActionBarStyles['icon']}>
                <AddToGroupButton
                  deviation={deviation}
                  actionBarType="secondary"
                />
              </span>
            )}
            {secondaryBarElementPlacement.boostDeviation && (
              <BoostButton
                deviation={deviation}
                className={desktopActionBarStyles['icon']}
              />
            )}
            {secondaryBarElementPlacement.meta.hasSecondaryMoreActionsMenu && (
              <span className={desktopActionBarStyles['icon']}>
                <MoreButton deviation={deviation} />
              </span>
            )}
          </Flex>
          <FluidMargin index={2} />
          <Flex alignItems="center" />
        </div>
        <FluidMargin index={3} />
        <div className={desktopActionBarStyles['icons-right']} />
      </div>
    </ActionBarStrip>
  );
};
SecondaryDesktopActionBar.displayName = 'SecondaryDesktopActionBar';

export default SecondaryDesktopActionBar;
